import { render, staticRenderFns } from "./Collaborate-with.vue?vue&type=template&id=2e71b984&scoped=true"
var script = {}
import style0 from "./Collaborate-with.vue?vue&type=style&index=0&id=2e71b984&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e71b984",
  null
  
)

export default component.exports